export default "__VITE_ASSET__C1VIFe$O__"